export const faqSelector = (state) => state.faq;
export const faqParamsSelector = (state) => state.faq.params;
